import { useEffect, useState } from "react";
import { supabase } from "../utils/supabase";
import DialogInput from "./DialogInput";
const Exercises = ({
  selectedBodyPart,
  currentDayData,
  setSelectedBodyPart,
}) => {
  const [exerciseData, setExerciseData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [customExercises, setCustomExercises] = useState([]);
  const [currentUserId, setCurrentUserId] = useState(null);
  const storedExerciseData = JSON.parse(localStorage.getItem("exerciseData"));
  const customExercisesCount = storedExerciseData?.reduce(
    (count, data) => (data.isCustom ? count + 1 : count),
    0
  );

  useEffect(() => {
    const fetchData = async () => {
      const customExercises = await fetchCustomExercises();
      setCustomExercises(customExercises);
      if (
        !selectedBodyPart ||
        ((currentUserId === "3cdf8cc0-6f83-4831-98a1-35b36dcd773d" ||
          currentUserId === null) &&
          storedExerciseData) ||
        customExercisesCount === customExercises.length
      )
        return;

      try {
        setIsLoading(true);

        const { data, error } = await supabase
          .from("exercises")
          .select("name, body_part");

        if (error) {
          throw error;
        }

        const exerciseData = data.map((item) => item);

        const combinedData = [...exerciseData, ...customExercises];

        setExerciseData(
          customExercises !== undefined ? combinedData : exerciseData
        );

        // Save data to localStorage
        localStorage.setItem("exerciseData", JSON.stringify(combinedData));
      } catch (error) {
        console.error("Error fetching exercise data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [selectedBodyPart]);

  async function fetchCustomExercises() {
    try {
      // Check if the user is authenticated
      const user = supabase.auth.getUser();
      if (!user) {
        return [];
      }

      // Fetch custom exercises from user metadata
      const { data: userData, error: userError } =
        await supabase.auth.getUser();
      setCurrentUserId(userData?.user.id);
      if (userError) {
        throw userError;
      }

      return userData?.user.user_metadata.customExercises || [];
    } catch (error) {
      console.error("Error fetching user data:", error.message);
      return [];
    }
  }
  return (
    <div className="flex flex-col items-center xl:ml-72 mx-auto mt-2">
      <DialogInput
        isLoading={isLoading}
        exerciseData={exerciseData}
        selectedBodyPart={selectedBodyPart}
        setSelectedBodyPart={setSelectedBodyPart}
        currentDayData={currentDayData}
        customExercises={customExercises}
        setCustomExercises={setCustomExercises}
      />
    </div>
  );
};

export default Exercises;
